<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>
<style>
@import "@/style/laptopScreen.css";
@import "@/style/phoneScreen.css";
@import "@/style/bigScreen.css";

/* @import url("https://fonts.googleapis.com/css2?family=Open+Sans&display=swap"); */
/* @import "./style/vswal.css"; */

@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@300;400&display=swap");
/* @font-face {
  font-family: "Open Sans";
  src: local("Open Sans"), url(./fonts/open-sans/OpenSans-Regular.ttf) format("truetype");
} */
#app {
  font-family: "Kanit";
}

/* .v-main__wrap {
  font-family: "Open Sans", "Kanit", sans-serif;
  background-color: #ffffff;
} */

/* .swal2-container {
  font-family: "Open Sans", "Kanit", sans-serif !important;
} */

/* xs	Small to large phone	            < 600px
sm	Small to medium tablet	          600px > < 960px
md	Large tablet to laptop	          960px > < 1264px*
lg	Desktop	                          1264px > < 1904px*
xl	4k and ultra-wide	                > 1904px* */
</style>
